module.exports = __webpack_public_path__ + "static/media/9.af315670.jpg";